module.exports = __webpack_public_path__ + "img/20190704161448395.f4f7cfad.png";